<template>
  <div>
    <section class="d-flex justify-content-between align-items-end">
      <div>
        <label for="search">{{ $t('generals.search') }}</label>
        <b-form-input
          id="search"
          v-model="query_params.search"
          @input="searchConstructors"
        />
      </div>
      <b-button
        v-b-modal.constructor-modal
        variant="primary"
        @click="openNewConstructorModal"
      >
        <feather-icon icon="PlusIcon" />
        {{ $t('generals.add') }}
      </b-button>
    </section>
    <b-card class="mt-2">
      <b-table
        :fields="fields"
        :items="GET_CONSTRUCTORS"
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
        </template>

        <template #cell(account)="props">
          <div class="d-flex flex-column justify-content-around">
            <div v-for="bank in props.item.account.banks" :key="bank.account_number">
              <p class="text-center mb-0">
                <b>{{ $t('references.bank_name') }}</b>
                {{ bank.bank_name }}
              </p>
              <p class="text-center">
                <b>{{ $t('references.rs') }}:</b> {{ bank.account_number }}
              </p>
            </div>
            <span class="text-center"> <b>{{ $t('references.vat') }}:</b> {{ props.item.account.nds }} </span>
            <span class="text-center"> <b>{{ $t('references.inn') }}:</b> {{ props.item.account.inn }} </span>
            <span class="text-center"> <b>{{ $t('references.okved') }}:</b> {{ props.item.account.oked }} </span>
          </div>
        </template>
        <template #cell(email_phone)="props">
          <div>
            <feather-icon icon="MailIcon" />
            <span v-if="props.item.account.email">
              {{ props.item.account.email }}
            </span>
            <span v-else>
              {{ $t('references.not_indicated') }}
            </span>
          </div>
          <div>
            <feather-icon icon="PhoneIcon" />
            <span v-if="props.item.account.phone_number">
              {{ phoneFormat(props.item.account.phone_number) }}
            </span>
            <span v-else>
              {{ $t('references.not_indicated') }}
            </span>
          </div>
        </template>
        <template #cell(actions)="props">
          <div class="d-flex justify-content-around">
            <b-button
              v-b-modal.constructor-modal
              variant="warning"
              size="sm"
              @click="editConstructor(props.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="deleteConstructor(props.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-75 bg-white p-1">
        <div class="d-flex align-items-center mb-0">
          <span class="text-nowrap text-black ml-1">
            {{ $t('generals.show_from') }}
          </span>
          <b-form-select
            v-model="query_params.page_size"
            :options="['5','10','15']"
            class="mx-1 text-black"
            @change="refresh"
          />
          <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
        </div>
        <div class="mb-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="GET_CONSTRUCTORS.count"
            :per-page="query_params.page_size"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @change="refresh"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </div>
    </b-card>
    <constructor-modal
      v-if="selected_constructor"
      :is-edit="editing"
      :def-form-obj="selected_constructor"
      @addSuccess="refresh"
    />
  </div>
</template>

<script>
import {
  BFormInput, BCard, BTable, BButton, VBModal, BFormSelect, BPagination,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapActions, mapGetters } from 'vuex'
import constructorModal from './components/constructorModal.vue'

export default {
  components: {
    BFormInput,
    BCard,
    BTable,
    BButton,
    FeatherIcon,
    constructorModal,
    BFormSelect,
    BPagination,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      currentPage: 1,
      query_params: {
        search: '',
        page_size: 10,
      },
      editing: false,
      selected_constructor: {
        account: {
          // nds: 15,
        },
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'width-50',
        },
        {
          key: 'title',
          label: 'references.title',
        },
        {
          key: 'address',
          label: 'references.address',
        },
        {
          key: 'boss',
          label: 'references.director',
        },
        {
          key: 'email_phone',
          label: 'references.email_and_phone',
        },
        {
          key: 'account',
          label: 'references.account',
          thClass: 'text-center',
        },
        {
          key: 'actions',
          label: 'references.actions',
          class: 'width-150',
        },
      ],
      timeout: 600,
    }
  },
  computed: {
    ...mapGetters('knowledgeBase', ['GET_CONSTRUCTORS']),
  },
  mounted() {
    this.FETCH_CONSTRUCTORS()
  },
  methods: {
    ...mapActions('knowledgeBase', ['FETCH_CONSTRUCTORS', 'DELETE_CONSTRUCTOR']),
    refresh() {
      this.FETCH_CONSTRUCTORS(this.query_params)
    },
    searchConstructors() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.refresh()
      }, 600)
    },
    openNewConstructorModal() {
      this.editing = false
      this.selected_constructor = {
        // phone_number: '+998',
        account: {
          // nds: 15,
          banks: [
            {
              account_number: '',
              bank_name: '',
              mfo: '',
            },
          ],
        },
      }
    },
    phoneFormat(phoneNumberString) {
      const cleaned = (`${phoneNumberString}`).replace(/\D/g, '')
      const match = cleaned.match(/^(998|)?(\d{2})(\d{3})(\d{2})(\d{2})$/)
      if (match) {
        const intlCode = (match[1] ? '+998 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4], '-', match[5]].join('')
      }
      return null
    },
    editConstructor(constructor) {
      this.editing = true
      this.selected_constructor = this.$_removeObjectConnection(constructor)
      this.$set(this.selected_constructor, 'phone_number', this.selected_constructor.account.phone_number)
      this.$set(this.selected_constructor, 'email', this.selected_constructor.account.email)
    },
    deleteConstructor(id) {
      this.$_showAreYouSureModal().then(res => {
        if (res) {
          this.DELETE_CONSTRUCTOR(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
  },
}
</script>

<style>

</style>
